export const ORIGEM = {
  SHIP_FROM_STORE: 'SHIP_FROM_STORE',
  PEGUE_NA_LOJA_HOJE: 'PEGUE_NA_LOJA_HOJE',
  PEGUE_NA_LOJA: 'PEGUE_NA_LOJA'
};

export function getListOrigens() {
  return [{
    label: 'Todos',
    value: '',
  },{
    label: getLabelOrigem(ORIGEM.SHIP_FROM_STORE),
    value: ORIGEM.SHIP_FROM_STORE,
  }, {
    label: getLabelOrigem(ORIGEM.PEGUE_NA_LOJA_HOJE),
    value: ORIGEM.PEGUE_NA_LOJA_HOJE,
  }, {
    label: getLabelOrigem(ORIGEM.PEGUE_NA_LOJA),
    value: ORIGEM.PEGUE_NA_LOJA,
  }];
}


export function getLabelOrigem(origem) {
  switch (origem) {
    case ORIGEM.SHIP_FROM_STORE:
      return 'Delivery';
    case ORIGEM.PEGUE_NA_LOJA_HOJE:
      return 'Pegue na Loja Hoje';
    case ORIGEM.PEGUE_NA_LOJA:
        return 'Pegue na Loja';
    default:
      return '';
  }
}